import { getTimeBasedUUID } from '@collector/shared-utils'
import { SportsApiClient } from '@collector/sportsapi-client'

import type { QueueIncidentType } from './types.js'

export type QueueIncidentStatus = 'Pending' | 'In Progress' | 'Error'

export type QueueIncidentError = unknown | null

export abstract class BaseIncident {
  readonly eventId: number

  public status: QueueIncidentStatus

  readonly time: number

  abstract type: QueueIncidentType
  abstract isConfirmable: boolean

  error: QueueIncidentError

  /**
   * Number of retry attempts made for this incident (used for timeout handling)
   */
  autoRetryCount = 0

  constructor(
    eventId: number,
    status: QueueIncidentStatus = 'Pending',
    time = new Date().getTime(),
    error: QueueIncidentError = null,
  ) {
    this.eventId = eventId
    this.status = status
    this.time = time
    this.error = error
  }

  static getUUID(): string {
    return getTimeBasedUUID()
  }

  public setStatus(status: Exclude<QueueIncidentStatus, 'pending'>): void {
    this.status = status
  }

  /**
   * Checks if this incident can be retried (hasn't exceeded maximum retry attempts)
   */
  public canRetry(): boolean {
    return this.autoRetryCount < 1
  }

  /**
   * Increments the retry count for this incident
   */
  public incrementAutoRetryCount(): void {
    this.autoRetryCount++
  }

  public abstract process(sportsApiClient: SportsApiClient): Promise<string>
}
